export const authDict = {
    'visitor':1,
    'user':2,
    'admin':3
}